<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="carregada; else carregando">
<form name="formLiberacao" #formLiberacao="ngForm" id="formLiberacao">
	<div class="row">
		<div class="col">
			<h3>Amortização antecipada para {{estadoInicial.idOperacaoAgente}}
				<small class="text-muted"> (Operação #ID: {{model?.id}})</small>
			</h3>
		</div>
	
		<div class="col-auto">
			<button *ngIf="formLiberacao.pristine"
				type="button" class="btn btn-danger" (click)="voltarParaLista ()">Cancelar</button>
			<button *ngIf="!formLiberacao.pristine" type="button" 
				class="btn btn-primary" bnConfirm tituloConfirm="Confirmação" msgConfirm="Descartar amortização antecipada?"
				(onConfirm)="voltarParaLista ()">Cancelar</button>
			<button id="btnSalvar" name="btnSalvar" [disabled]="!formLiberacao.valid" type="button" (click)="salvar()"
				class="btn btn-primary" type="button">Enviar</button>
		</div>
	</div>
    <div class="row">
        <div class="bn-form-group col-md-6">
            <label class="form-label"><b>Valor total</b></label>
            <input type="text" class="form-control" name="valorAmortizacaoAntecipada" [(ngModel)]="model.valorTotalAmortizacaoAntecipada"
                bnMask="MOEDA" required />
        </div>
        <div class="bn-form-group col-md-6">
            <label class="form-label"><b>Data do pagamento</b></label>
            <bn-datepicker name="dataPagamentoAmortizacao"
                    [(ngModel)]="model.dataPagamentoAmortizacao" required></bn-datepicker>
        </div>
    </div>
    <div class="row linha-titulo-fluxo-amort-antecipada">
        <div class="col-md-6">
            <h4>Fluxo após amortização antecipada
            </h4>
        </div>
        <div class="col-md-6" *ngIf="temAmortizacoesAntecipadas">
            <div class="form-check text-end">
                <input type="checkbox" class="form-check-input" id="mostrarAmortizacoesAntecipadas" name="mostrarAmortizacoesAntecipadas" [(ngModel)]="mostrarAmortizacoesAntecipadas">
                <label class="form-check-label" for="mostrarAmortizacoesAntecipadas">Mostrar amortizações antecipadas</label>
              </div>
        </div>
    </div>
    <div class="table-responsive">
    <table class="table table-hover">
        <thead>
            <tr>
                <th scope="col">Data da amortização</th>
                <th scope="col" class="coluna-moeda">Valor da amortização</th>
            <tr>
        </thead>
        <tbody>
            <tr *ngFor="let amort of model.fluxoParcelasAposAmortizacao; let i = index">
                <td *ngIf="mostrarAmortizacoesAntecipadas || !amort.antecipada"><bn-datepicker name="dataAmortizacao{{i}}"
                    [(ngModel)]="amort.data" [disabled]="true"></bn-datepicker></td>
                <td *ngIf="mostrarAmortizacoesAntecipadas || !amort.antecipada" class="coluna-moeda"><input type="text" 
                    class="form-control" name="valorAmortizacao{{i}}"
                    [(ngModel)]="amort.valor" bnMask="MOEDA" required [disabled]="amort.antecipada"
                    [ngbTooltip]="amort.antecipada ? 'Amortização antecipada' : ''" /></td>
            </tr>
        </tbody>
    </table>
    </div>
</form>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
	<div class="table-responsive">
		<table class="table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center">Erro(s) encontrado(s)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ocorrencia of ocorrencias">
					<td>{{ ocorrencia.mensagem }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-template #carregando>
<div class="loading-pesquisa">
	<i class="bn-loading"></i>
</div>
</ng-template>